import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/views/HomePage.vue';

// Lazy load other routes for code splitting
const Benefits = () => import('@/views/Benefits.vue');
const Positions = () => import('@/views/Positions.vue');
const LoadingTest = () => import('@/views/LoadingTest.vue');
const SolutionsPage = () => import('@/views/SolutionsPage.vue');
const OfferForm = () => import('@/views/OfferForm.vue');
const OfferComparison = () => import('@/views/OfferComparison.vue');
const Vibes = () => import('@/views/Vibes.vue');
const NotFound = () => import('@/views/NotFound.vue');

const routes = [
  { path: '/loading-test', name: 'LoadingTest', component: LoadingTest },
  { path: '/', name: 'HomePage', component: HomePage },
  { path: '/benefits', name: 'Benefits', component: Benefits },
  { path: '/solutions', name: 'Solutions', component: SolutionsPage },
  { path: '/community', name: 'Community', component: HomePage },
  { path: '/positions', name: 'Positions', component: Positions },
  { path: '/careers', redirect: '/positions' },
  { path: '/vibes', name: 'Vibes', component: Vibes },
  { path: '/generate', name: 'OfferForm', component: OfferForm },
  { path: '/offer', name: 'OfferComparison', component: OfferComparison },
  { path: '/404', name: 'NotFound', component: NotFound },
  { path: '/:pathMatch(.*)*', name: 'NotFoundCatchAll', component: NotFound }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  // Add fallback for 404s in production
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

// Force scroll to top after each route change
router.afterEach((to, from) => {
  // Use nextTick to ensure DOM is updated
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);
});

export default router;